module.exports = __webpack_public_path__ + "img/header-msg-img.d63ff971.svg";